import React from "react";
import { store } from "app/store";

const RightPanelContainer = ({ id, children, style, fill, size }) => {
  const colors = store.getState().settings.colors;

  return (
    <div
      id={id}
      className={
        size === "small"
          ? "deal-right-panel-container small"
          : "deal-right-panel-container"
      }
      style={{
        backgroundColor: colors.background_color,
        ...style
      }}
    >
      {children}
    </div>
  );
};

export { RightPanelContainer };
